import axios from 'axios'

const state = () => ({
  faq: []
})

const getters = {
  faq(state) {
    return state.faq
  }
}

const mutations = {
  SET_FAQ(state, payload) {
    state.faq = payload
  },
  DELETE_FAQ(state, id) {
    state.faq = state.faq.filter((x) => x.id != id);
  },
  ADD_FAQ(state, data) {
    state.faq.push(data)
  },
  UPDATE_FAQ(state, payload) {
    state.faq = state.faq.map((x) => {
      if (x.id == payload.id) return payload;
      else return x;
    })
  }
}

const actions = {
  getFaq({ commit }) {
    axios.get('https://api.geomalaka.uz/api/main/savol-javoblar/')
      .then((res) => {
        commit("SET_FAQ", res.data)
      })
      .catch((error) => { this._vm.$toast(error.message, {type: 'error'}); })
  },

  deleteFaq({ commit }, id) {
    axios.delete(`https://api.geomalaka.uz/api/main/savol-javoblar/${id}/`)
      .then((res) => {
        commit("DELETE_FAQ", id)
        this._vm.$toast('Deleted', {type: 'success'})
      })
      .catch((error) => { this._vm.$toast(error.message, {type: 'error'}); })
  },

  addFaq({ commit }, payload) {
    axios.post('https://api.geomalaka.uz/api/main/savol-javoblar/', payload)
      .then((res) => {
        commit("ADD_FAQ", res.data)
        this._vm.$toast(res.statusText, {type: 'success'});
      })
      .catch((error) => { this._vm.$toast(error.message, {type: 'error'}); })
  },
  updateFaq({ commit }, payload) {
    axios.put(`https://api.geomalaka.uz/api/main/savol-javoblar/${payload.id}/`, payload.data)
      .then((res) => {
        commit("UPDATE_FAQ", res.data)
        this._vm.$toast('Successful', {type: 'success'})
      })
      .catch((error) => { this._vm.$toast(error.message, {type: 'error'}); })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

